import { find } from 'lodash';
import React, { useContext, useState } from 'react';

import { CorporateOfferContext } from 'modules/offers/context/CorporateOfferContext';
import { CorporateAudienceType } from 'modules/offers/offersServices/CorporateOffersService';

import { offerTerms } from '../../listForSelectingData/dataForLists';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import {
  Container,
  SuccessStories,
  Wrapper,
} from '../components/StyledElements';
import WellnessSection from '../components/WellnessSection';
import useCreateRefsForClick, {
  handlerRefClick,
} from '../hooks/useCreateRefsForClick';
import { Device } from '../models';
import PreviewHeader from '../PreviewHeader';

import BroughtBySection from './components/BroughtBySection';
import FAQSection from './components/FAQSection';
import OfferCodeForm from './components/OfferCodeForm';

type PreviewPageCorporateProps = {
  logo: string;
  background?: string;
  chosenDevice: Device;
  closePreview: () => void;
};

const PreviewPageCorporate = ({
  logo,
  chosenDevice,
  closePreview,
}: PreviewPageCorporateProps) => {
  const {
    offerDraft: { settings },
    companyName,
  } = useContext(CorporateOfferContext);
  const [activeDevice, setActiveDevice] = useState(chosenDevice);

  const isTablet = activeDevice === Device.Tablet;
  const isMobile = activeDevice === Device.Mobile;
  const isDesktop = activeDevice === Device.Desktop;

  const isEmployee = settings.audienceType === CorporateAudienceType.Employee;
  const includeDepartment = settings.includeDepartment === 'true';

  const refsCount = isEmployee ? 2 : 1;
  const { refs } = useCreateRefsForClick(refsCount);

  const monthPeriod =
    find(offerTerms, { BEformat: settings.offerTerm })
      ?.displayDownloadPageName || '';

  return (
    <Container>
      <PreviewHeader
        title="offer"
        activeDevice={activeDevice}
        closePreview={closePreview}
        setActiveDevice={setActiveDevice}
      />
      <Wrapper $isMobile={isMobile} $isTablet={isTablet}>
        <Header isMobile={isMobile} />
        <HeroSection
          title={`Get ${monthPeriod} premium access for free!`}
          isMobile={isMobile}
          isTablet={isTablet}
          isLarge
        >
          <OfferCodeForm
            isDesktop={isDesktop}
            includeDepartment={includeDepartment}
            label="Enter access code..."
          />
        </HeroSection>
        <BroughtBySection
          isMobile={isMobile}
          isDesktop={isDesktop}
          accountName={companyName}
          logo={logo}
        />
        <WellnessSection
          goToNextSection={handlerRefClick(refs[0])}
          isMobile={isMobile}
        />
        {isEmployee && (
          <FAQSection
            ref={refs[0]}
            isMobile={isMobile}
            isDesktop={isDesktop}
            goToNextSection={handlerRefClick(refs[1])}
          />
        )}
        <SuccessStories
          ref={refs[refsCount - 1]}
          isMobile={isMobile}
          isTablet={isTablet}
          $isDesktop={isDesktop}
          title="Trusted by 1000’s of people like you"
        />
        <Footer isMobile={isMobile} />
      </Wrapper>
    </Container>
  );
};

export default PreviewPageCorporate;
